/**
 * 学校介绍数据访问层
 */
import profilesJson from '@data/schools/profiles.json'
import type { SchoolName } from './types'

export interface SchoolProfile {
  key: 'yz1' | 'ez' | 'shiyan' | 'ykyz' | 'mzh'
  name: SchoolName
  full_name: string
  founded: string
  address: string
  level: string
  boarding: string
  scale: string
  website: string
  phone: string
  features: string[]
  enrollment_2025: { plan: number | null; note: string }
  image_main: string
  image_map: string
}

export interface ProfilesData {
  version: string
  updated_at: string
  disclaimer: string
  schools: SchoolProfile[]
}

export const PROFILES = profilesJson as unknown as ProfilesData

export const PROFILES_BY_NAME: Record<SchoolName, SchoolProfile> = PROFILES.schools.reduce(
  (acc, p) => ({ ...acc, [p.name]: p }),
  {} as Record<SchoolName, SchoolProfile>
)

/** 判断某字段是否为占位（"（待补："开头） */
export function isPlaceholder(value: string | null | undefined): boolean {
  if (!value) return true
  return value.startsWith('（待补')
}
